import { EntryCollection, Asset, Entry } from 'contentful';
import { RichTextContent } from 'types/RichTextContent';
import { TeamMember } from 'types/TeamMember';

import { getEntries, getEntry } from './ContentfulClient';

type ContentfulNewsPost = {
  title: string;
  slug: string;
  image: Asset;
  blurb: string;
  content: RichTextContent;
  link: string;
  publishDate: string;
  isFeatured: boolean;
  authors?: Entry<TeamMember>[];
};

const transformNewsPost = (newsPost: Entry<ContentfulNewsPost>) => {
  const { sys, fields } = newsPost;
  const { title, slug, image, blurb, content, link, publishDate, authors, isFeatured } = fields;

  return {
    title,
    slug,
    blurb,
    content,
    link,
    isFeatured,
    id: sys.id,
    imageUrl: image?.fields?.file?.url || '',
    publishDate: new Date(publishDate),
    ...(authors && { authors: authors.map(({ fields }) => fields) }),
  };
};

const transformAllNewsPosts = (news: EntryCollection<ContentfulNewsPost>) => {
  return news.items.map(transformNewsPost);
};

export const getAllNewsPosts = async () => {
  return transformAllNewsPosts(await getEntries<ContentfulNewsPost>('news'));
};

export const getNewsPost = async (id: string) => {
  return transformNewsPost(await getEntry<ContentfulNewsPost>(id));
};
